import { render, staticRenderFns } from "./SunMenu.vue?vue&type=template&id=caace0bc&scoped=true&"
import script from "./SunMenu.vue?vue&type=script&lang=js&"
export * from "./SunMenu.vue?vue&type=script&lang=js&"
import style0 from "./SunMenu.vue?vue&type=style&index=0&id=caace0bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caace0bc",
  null
  
)

export default component.exports